import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=fb23c8ae&scoped=true&"
import script from "./BasicSettings.vue?vue&type=script&lang=js&"
export * from "./BasicSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb23c8ae",
  null
  
)

export default component.exports